import type { MetaDataDescriptionsInterface } from '@nts/std/interfaces';
import { Expose } from "@nts/std/serialization";

export class MetaDataDescriptions implements MetaDataDescriptionsInterface {

    @Expose()
    displayNameKey: string;

    @Expose()
    shortNameKey: string;

    @Expose()
    descriptionKey: string;

    @Expose()
    displayName: string;

    @Expose()
    shortName: string;

    @Expose()
    description: string;

}
